import { Alert } from "../base/Alert";
import Card from "../shared/Card/Card";
import LoadingWheel from "../shared/LoadingWheel";
import useFeatures from "../../data/Feature/useFeatures";
import { errorResolver } from "../../utils/errorResolver";
import useCustomerFeatures from "../../data/CustomerFeature/useCustomerFeatures";
import Form from "../base/Form/Form";
import { FormToggle } from "../base/Form/FormToggle";
import { SubmitHandler, UseFormReturn } from "react-hook-form";

export interface CustomerFeatureFormFields {
  [field: string]: boolean;
}

interface EditCustomerFeatureListProps {
  customerId: string;
  onSubmit: SubmitHandler<CustomerFeatureFormFields>;
  onReady: (methods: UseFormReturn<CustomerFeatureFormFields>) => void;
}

export function EditCustomerFeatureList({
  customerId,
  onSubmit,
  onReady,
}: EditCustomerFeatureListProps) {
  const { features } = useFeatures();
  const { customerFeatures } = useCustomerFeatures(customerId);

  const getDefaultValues = () => {
    let values: { [x: string]: boolean } = {};

    features.data?.forEach((feature) => {
      values[feature.id] = customerFeatures.data!.some(
        (f) => f.featureId === feature.id,
      );
    });

    return values;
  };

  return (
    <Card title="Features" bodyClassName="px-4">
      {features.isLoading || customerFeatures.isLoading ? (
        <div className="py-4">
          <LoadingWheel />
        </div>
      ) : features.isError ? (
        <div className="p-4">
          <Alert
            severity="error"
            title="Error getting features"
            message={errorResolver(features.error)}
          />
        </div>
      ) : customerFeatures.isError ? (
        <div className="p-4">
          <Alert
            severity="error"
            title="Error getting customer features"
            message={errorResolver(customerFeatures.error)}
          />
        </div>
      ) : (
        <Form<CustomerFeatureFormFields>
          onReady={onReady}
          onSubmit={onSubmit}
          defaultValues={getDefaultValues()}
          className="divide-y divide-gray-100"
        >
          {({ control }: UseFormReturn<CustomerFeatureFormFields>) =>
            features.data?.map((feature, i) => {
              return (
                <div className="py-4 flex items-center justify-between" key={i}>
                  <span className="text-sm font-medium">{feature.name}</span>
                  <FormToggle<CustomerFeatureFormFields>
                    name={feature.id}
                    control={control}
                    toggleProps={{}}
                  />
                </div>
              );
            })
          }
        </Form>
      )}
    </Card>
  );
}
